import type { ScreenLayout } from "@observe-tech/utils";

export const defaultScreenLayoutValues: Omit<ScreenLayout, "id"> = {
  isShowing: true,
  screenType: "welcome",
  screenData: {
    fullScreen: null,
    halfScreenLeft: null,
    halfScreenRight: null,
    gridLayout: {
      columns: 2,
      rows: 2,
    },
    nCams: 1,
    videoAspectRatio: 1,
    cameraGrid: {
      "1-1": null,
      "1-2": null,
      "1-3": null,
      "1-4": null,
      "2-1": null,
      "2-2": null,
      "2-3": null,
      "2-4": null,
      "3-1": null,
      "3-2": null,
      "3-3": null,
      "3-4": null,
      "4-1": null,
      "4-2": null,
      "4-3": null,
      "4-4": null,
    },
    cageGrid: {
      "1-1": null,
      "1-2": null,
      "1-3": null,
      "1-4": null,
      "2-1": null,
      "2-2": null,
      "2-3": null,
      "2-4": null,
      "3-1": null,
      "3-2": null,
      "3-3": null,
      "3-4": null,
      "4-1": null,
      "4-2": null,
      "4-3": null,
      "4-4": null,
    },
  },
  feedScreenData: {
    sites: { siteIds: [] },
    columns: [],
    copilotColumns: [],
    filters: [],
  },
};
